import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { LanguageTextListRes } from "../../types/LanguageTextList";
import Cookies from "js-cookie";
import { useAppDispatch } from "../../utils/hooks";
import {
  recordsToMap,
  recordsToNormMap,
  updateLanguageTextList,
} from "../Slices/LanguageTextListSlice";

export const useFetchLanguageTextList = () => {
  const language_id = Cookies.get("language_id");
  const dispatch = useAppDispatch();

  return useQuery<LanguageTextListRes, Error>(
    ["language/get-language-words", language_id || "default"],
    async () => {
      const body: Record<string, string> = {};
      if (language_id) body.language_id = language_id;

      const response = await axiosInstance.post<LanguageTextListRes>(
        "language/get-language-words",
        body,
      );

      const data = response.data;
      const records = data?.data?.Records || [];
      const map = recordsToMap(records);
      const mapNorm = recordsToNormMap(records);
      const enriched: LanguageTextListRes = {
        ...data,
        data: {
          ...data.data,
          Records: records,
          map,
          mapNorm,
        },
      };

      dispatch(updateLanguageTextList(enriched));
      return enriched;
    },
    {
      // Always try; API falls back to default language if no cookie
      retry: 1,
      staleTime: 5 * 60 * 1000,
      cacheTime: Infinity,
      // Keep showing cached Redux/localStorage dict while refreshing
      refetchOnWindowFocus: false,
    },
  );
};
